// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1uBjF","legacyBtn":"MutateMid_legacyBtn__3cIK3"};